module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("Leaders Are Different")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("“Leaders are different,” Samantha said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s it?” Blake said in a tone that revealed his concern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Blake. Your performance has been outstanding; you’re a great individual contributor, but I couldn’t get enough support for you to become the team leader.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That doesn’t make sense to me,” said Blake, in disbelief. “Outstanding performance—no promotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right. We do value results around here—but there’s something missing.” Samantha stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blake leaned across the table, waiting on her next words, but she said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He finally broke the silence, “What’s missing?” He wanted to know—he needed to know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s really hard for me to put it into words,” she said hesitantly. “That’s why I said leaders are different.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you tell me how leaders are different?” Blake asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not sure how to describe it, but I know it when I see it.” Samantha sounded uncertain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("“Samantha, are you trying to tell me that I’ll never get a promotion?” Blake wasn’t sure he even wanted the answer to that question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Blake, I’m not. However, there is a lot more to leadership than great individual work … you’re just not "), _c('em', [_vm._v("acting")]), _vm._v(" like a leader,” she said, in a genuine attempt to help.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('strong', [_c('em', [_vm._v("There is a lot more to leadership"), _c('br'), _vm._v("than great individual work")])]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("“How do I act like a leader?” Blake’s frustration was starting to show.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leaders are different.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I got that.” Blake was hanging on Samantha’s every word. He waited, but Samantha didn’t seem to have anything else to say. Blake decided one final question was in order: “Do you have any advice for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You need to figure this out for yourself. You know a lot of leaders; why don’t you talk to some of them and see if they can help?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Samantha wasn’t totally satisfied with her response, but she hoped Blake would take her counsel. He did seem to have a lot of potential.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("• • •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As Blake drove home, he replayed the previous five years at Dynastar in his head. He felt as if he’d gotten off to a "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("fast start, maybe the fastest start in history. He had practically saved the company in his first year—single-handedly. But since then, he had moved three times within the company and been passed over twice for leadership positions. He was only 28 years old, but he felt much older. He was tired. He was stuck. And now he had to tell Megan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he pulled in the driveway, he thought, I wish we didn’t have such a big house payment, then this promotion and the raise wouldn’t seem so important. He also hoped that Megan was in a good mood. Maybe she had gotten a nap today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he entered the house, Clint, their nine-month old, was screaming about something. None of them had been sleeping much, and Megan didn’t look like she’d had a nap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you?” Blake asked, mustering as much of a smile as he could.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” Megan said, “I’m tired.” As she spoke, she stepped into the light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you been crying?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A little.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The doctor called—” She stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And … ?” Blake probed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m pregnant!” Megan burst into tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great,” Blake said, with little emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great? You’re never home, we don’t sleep, and we can hardly pay the bills. What’s great about another child?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("The part about “hardly pay the bills” hit Blake like an arrow to his heart. He decided to let it go even though it hurt him deeply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen,” he said. “Another child is a wonderful gift! We’ll sleep again someday. And I’ll make more money—someday. And about my never being home, I’ll keep working on that part, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He paused and then said, “I’m thankful we’re having another baby. We always talked about having another one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We were going to do that later,” she sobbed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It will be okay.” Blake hugged Megan as tightly as he ever had.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she stopped crying, he said, “You go lie down and take a quick nap. I’ll take care of Clint and fix us something to eat. I’ll call you in an hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you” was all that Megan could say, as she shuffled off to the bedroom. A nap was the greatest gift Blake could have given her in that moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An hour later, much had changed, or at least it felt like it. Clint was happy, Megan was a little more rested and relaxed, and Blake had made a wonderful dinner—well, he had cooked a frozen pizza.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Megan came back into the kitchen, she said, “I’m sorry I was so emotional earlier. You’re right, we do want another child, and there’s probably never a good time.” She smiled, “Plus, the stress that comes with not "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("sleeping makes everything look more monumental than it really is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here’s what I know,” Blake added. “It will be great! It may be bumpy, but it will be good.” Megan had always loved Blake’s optimism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How was work today?” Megan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well … ” Blake really didn’t want to go there. The timing seemed extremely bad. “It was fine,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh-oh,” Meagan said. Blake was not a good liar. “You do still have a job, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly. What would make you think I don’t have a job?” Blake was thankful he did still have a job; perhaps that would make the next part easier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do have a job. I don’t have a promotion,” he said in a matter-of-fact tone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, dear.” Megan could feel his pain. “What’d they say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do great work … ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But leaders are different.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does that mean?” Megan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t really know. I’ve only had a couple of hours to think about it. I think they’re telling me I’m not a leader.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve always been one before.” Megan instinctively came to Blake’s defense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I know. But Dynastar seems to have a different standard of leadership. I’m still trying to figure it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("“What are you going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Three things,” Blake said. “Keep working hard. Keep trying to grow, and I’m going to call Debbie Brewster.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do all that,” Megan said, “and I’ll pray.” She smiled; Blake didn’t.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 84
// module chunks = 0